import { EventEmitter, Injectable } from "@angular/core";

@Injectable({providedIn: 'root'})
export class FreeTrialService{

        public freeTrialEndsIn = new EventEmitter<number>();
}